















import Vue, { PropType } from 'vue'
import { faGithub, faLinkedin } from '@fortawesome/free-brands-svg-icons'
import { capitalizeWords } from '~/utils/string'
import { ciExternalLink } from '~/icons/source/regular/external-link'

enum ExternalLinkType {
  LINKEDIN = 'linkedin',
  GITHUB = 'github',
  RENTAL = 'rental'
}

interface ExternalLink {
  domain: string
  type: string
  url: string
}

export default Vue.extend({
  props: {
    externalLink: {
      type: Object as PropType<ExternalLink>,
      required: true
    },
    linkClass: {
      type: String,
      required: false,
      default: ''
    }
  },
  computed: {
    link(): { icon: any; text: string } {
      switch (this.externalLink.type) {
        case ExternalLinkType.LINKEDIN: {
          return {
            icon: faLinkedin,
            text: 'LinkedIn'
          }
        }
        case ExternalLinkType.GITHUB: {
          return {
            icon: faGithub,
            text: 'GitHub'
          }
        }
        case ExternalLinkType.RENTAL: {
          return {
            icon: ciExternalLink,
            text: capitalizeWords(this.$t('rent online'))
          }
        }
        default: {
          return {
            icon: ciExternalLink,
            text: this.$t('external url')
          }
        }
      }
    }
  }
})
